import { Directive, ElementRef, Inject, Input, Optional } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { Subscription } from 'rxjs'
import { IdentityService } from 'main/services/identity.service'

@Directive({
  selector: '[permissionEnable]',
})
export class PermissionEnableDirective {
  @Input('permissionEnable') permission: string
  private subscription?: Subscription

  constructor (
    private identity: IdentityService,
    private element: ElementRef<HTMLElement>,
    @Inject(NG_VALUE_ACCESSOR) @Optional() private cva?: ControlValueAccessor,
  ) { }

  ngAfterViewInit () {
    this.subscription = this.identity.identityUpdated$.subscribe(() => this.update())
  }

  ngOnDestroy () {
    this.subscription?.unsubscribe()
  }

  private update () {
    const disabled = !this.identity.hasPermission(this.permission)
    this.cva?.setDisabledState?.(disabled)
    if (disabled) {
      this.element.nativeElement.setAttribute('disabled', 'disabled')
    } else {
      this.element.nativeElement.removeAttribute('disabled')
    }
  }
}
